import React, { memo, useContext, useEffect } from "react";

import { ErrorBoundary } from "react-error-boundary";
import { ErrorFallback } from "../../..";
import { BotContext } from "../../../context";
import HistoryNoLogin from "./components/HistoryNoLogin";
// import { AnswerBubble } from ".";
import { HistoryWithLogin } from "./components/HistoryWithLogin";

const History = memo((props) => {
  const { setGlobalProps } = useContext(BotContext);
  useEffect(() => {
    setGlobalProps(props);
  }, []);
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback} id="x">
      {process.env.REACT_APP_LOGIN === "false" ? (
        <HistoryNoLogin />
      ) : (
        <HistoryWithLogin />
      )}
    </ErrorBoundary>
  );
});
export { History };
